import { WidgetMap, calculatePercentage } from './moodboardUtilities';
import styles from './ChartCustomTooltip.module.scss';

interface CustomTooltipProps {
  active?: boolean;
  barKeys: string[];
  payload?: {
    value: number;
    name: string;
    fill: string;
    payload: WidgetMap;
  }[];
}

const ChartCustomTooltip = ({ active, barKeys, payload }: CustomTooltipProps) => {
  if (active && payload && payload.length) {
    return (
      <div className={styles.customTooltip}>
        {payload.map((entry, index) => {
          const percentage = calculatePercentage(entry.payload, barKeys, entry.value);
          return (
            <div key={`tooltip-${index}`} className='label'>
              <p style={{ color: entry.fill }} className={styles.tooltipPercentageNum}>{`${percentage} %`}</p>
              <p className={styles.tooltopMoodName}>{`${entry.name}`}</p>
            </div>
          );
        })}
      </div>
    );
  }

  return null;
};

export default ChartCustomTooltip;
